module.exports = __webpack_public_path__ + "static/media/rare_gem_small.f2054728.png";